import {
  AuthorizationAPIClient,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'
import { computed, ComputedRef, ref, Ref } from 'vue'
import { LOGIN_CONSTANTS } from 'frontcore/constants'
import { 
  PermissionExtraParameters, 
  PermissionStorage,
} from 'frontcore/domain/authorization/model/PermissionService.d'
import {
  ProfileRequestService,
  UserProfile,
} from 'frontcore/domain/profile/model/Profile.d'

export interface PermissionSAMLUseCase {
  loading: Ref<boolean>
  isSamlLogin: ComputedRef<boolean>
  authorize: (extraParameters?: PermissionExtraParameters) => void
  continueAuthorizeProcess: (requestId: string) => Promise<{profile: UserProfile, payload?: PermissionExtraParameters}>
}

const usePermissionSAML = (
  permissionStorage: PermissionStorage,
  samlApiClient: AuthorizationAPIClient,
  profileService: ProfileRequestService,
  loginType?: number): PermissionSAMLUseCase => {

  const isSamlLogin = computed(() => loginType === LOGIN_CONSTANTS.LOGIN_TYPE.saml)
  const loading = ref(false)
  const authorize = (extraParameters?: PermissionExtraParameters) => {
    permissionStorage.clear()
    if (extraParameters) {
      permissionStorage.set(extraParameters)
    }
    const url = window.location.href
    const urlObj = new URL(url)
    urlObj.searchParams.delete('request_id')

    const encodedURI = encodeURIComponent(urlObj.toString())
    const redirectUri = `${API_URL}/saml/?redirect_to=${encodedURI}`
    window.location.replace(redirectUri)
  }

  const continueAuthorizeProcess = async (requestId: string) => {
    loading.value = true
    const extraParameters = permissionStorage.get()
    const payload = { 
      request_id: requestId,
      ...extraParameters,
    }
    permissionStorage.clear()
    const token = await samlApiClient.login(payload)
    const profile = await profileService.retrieve(token)
    loading.value = false
    return { profile, payload: extraParameters }
  }
  return {
    loading,
    isSamlLogin,
    authorize,
    continueAuthorizeProcess,
  }
}

export default usePermissionSAML
